/**
 * @param {ReturnType<import("./fetchOrgUsers").flattenOrgUsersForPicker>} availableUsers
 * @param {number[]} selectedUserIndexes
 * @param {(userIndex: number) => string} [orphanLabel]
 */
export function buildUserMultiSelectOptions(availableUsers, selectedUserIndexes, orphanLabel) {
  const selected = selectedUserIndexes || [];
  const list = Array.isArray(availableUsers) ? availableUsers : [];
  const apiIds = new Set(list.map((u) => Number(u.userIndex)));
  const orphans = selected.filter((id) => !apiIds.has(Number(id)));

  const base = list
    .slice()
    .sort((a, b) => {
      const orgCmp = String(a.orgName).localeCompare(String(b.orgName));
      if (orgCmp !== 0) return orgCmp;
      return String(a.name || a.email).localeCompare(String(b.name || b.email));
    })
    .map((u) => ({
      value: String(u.userIndex),
      label: formatUserPickerLabel(u),
      group: u.orgName || "Other",
    }));

  const labelFn = orphanLabel || ((id) => `User ${id}`);
  const extra = orphans.map((id) => ({
    value: String(id),
    label: labelFn(id),
    group: "Not in directory",
  }));

  return [...base, ...extra];
}

export function formatUserPickerLabel(user) {
  const name = user.name || user.email || `User ${user.userIndex}`;
  const emailPart = user.email && user.name ? ` (${user.email})` : "";
  return `${name}${emailPart}`;
}

/** Map MultiSelectDropdown string values to numeric user_index values. */
export function parseUserIdsFromMultiSelectValues(stringValues) {
  return (stringValues || [])
    .map((v) => Number(v))
    .filter((n) => !Number.isNaN(n));
}
